import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Other Requirement|Metadata|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ClientMetadata,
	portal: 'SP',
};

export type SPOtherRequirementsMetadataLocNames =
	| 'SPOtherRequirementsMetadataTitleSection'
	| 'SPOtherRequirementsMetadataButtonEdit'
	| 'SPOtherRequirementsMetadataButtonCancel'
	| 'SPOtherRequirementsMetadataButtonSave'
	| 'SPOtherRequirementsMetadataButtonSaveSuccess'
	| 'SPOtherRequirementsMetadataNoChanges'
	| 'SPOtherRequirementsMetadataNone';

export const spOtherRequirementsMetadataLocs: LocDefs<SPOtherRequirementsMetadataLocNames> = {
	SPOtherRequirementsMetadataTitleSection: {
		defaultValue: 'Metadata',
		description: 'Section title for other requirement metadata',
		displayPath: `${pathStart}Section title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPOtherRequirementsMetadataButtonEdit: {
		defaultValue: 'Edit',
		description: 'Edit button / tooltip',
		displayPath: `${pathStart}Edit`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPOtherRequirementsMetadataButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button / tooltip',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPOtherRequirementsMetadataButtonSave: {
		defaultValue: 'Save',
		description: 'Save button / tooltip',
		displayPath: `${pathStart}Save`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPOtherRequirementsMetadataButtonSaveSuccess: {
		defaultValue: 'Changes Saved',
		description: 'Save success message',
		displayPath: `${pathStart}Save success`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPOtherRequirementsMetadataNoChanges: {
		defaultValue: 'You must make at least one change',
		description: 'Shown when saving without any changes',
		displayPath: `${pathStart}No changes`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPOtherRequirementsMetadataNone: {
		defaultValue: 'No metadata found.',
		description: 'Shown when the catalog has no metadata',
		displayPath: `${pathStart}None`,
		displayType: 'Content',
		...sharedProperties,
	},
};

export type SPOtherRequirementsMetadataLocType = LocMap<SPOtherRequirementsMetadataLocNames>;
